import { prepareClientErrorsToMixpanel } from './prepareClientErrorsToMixpanel';
/**
 * Separates form errors into minors-related and other errors
 * @param {Object} allFormErrors - Object containing all form validation errors
 * @returns {Object} Processed validation errors ready for Mixpanel
 */
export const separateFormErrors = (allFormErrors) => {
  const minorsErrors = {};
  const restErrors = {};

  // eslint-disable-next-line no-restricted-syntax
  for (const errorName in allFormErrors) {
    if (errorName.includes('minors[')) {
      if (!minorsErrors.minors) {
        minorsErrors.minors = [];
      }

      const regex = /minors\[(\d+)\]\.(\w+)/;
      const match = errorName.match(regex);

      if (match) {
        if (!minorsErrors.minors[+match[1]]) {
          minorsErrors.minors[+match[1]] = {};
        }

        minorsErrors.minors[+match[1]][match[2]] = allFormErrors[errorName];
      }
    } else {
      restErrors[errorName] = allFormErrors[errorName];
    }
  }

  return {
    ...prepareClientErrorsToMixpanel(minorsErrors),
    ...prepareClientErrorsToMixpanel(restErrors),
  };
};
